import { useContext } from "react";
import { ConfigContext } from "../providers/ConfigContext";
import useMakeApiRequest from "./useMakeApiRequest";

const useGetSession = () => {
  const { apiBase } = useContext(ConfigContext);
  const makeApiRequest = useMakeApiRequest("GET");

  const getSession = async () => 
    await makeApiRequest(`${apiBase}/api/session`, {});

  return [getSession];
};

export default useGetSession;
